(function () {
  if (!document.body.classList.contains('template-ritual')) return;

  const sticky = document.querySelector('[data-ritual-sticky-atc]');
  if (!sticky) return;

  const sectionId = sticky.dataset.sectionId;
  const productInfo = document.querySelector(`product-info[data-section="${sectionId}"]`) || document.querySelector('product-info');
  const mainSubmit = productInfo?.querySelector('.product-form__submit[name="add"]');
  const stickySubmit = sticky.querySelector('[data-ritual-sticky-submit]');
  const stickyLabel = sticky.querySelector('[data-ritual-sticky-submit-label]');
  const stickyPrice = sticky.querySelector('[data-ritual-sticky-price]');
  const mobileMq = window.matchMedia('(max-width: 749px)');

  if (!mainSubmit || !stickySubmit) return;

  let observer;

  function syncFromMainSubmit() {
    stickySubmit.disabled = mainSubmit.disabled;
    const label = mainSubmit.querySelector('span:not(.loading__spinner)')?.textContent?.trim();
    if (label && stickyLabel) stickyLabel.textContent = label;
  }

  function syncPrice() {
    const priceSource = document.querySelector(`#price-${sectionId}`);
    if (priceSource && stickyPrice) stickyPrice.innerHTML = priceSource.innerHTML;
  }

  function setVisible(visible) {
    if (visible) {
      sticky.removeAttribute('hidden');
      sticky.setAttribute('aria-hidden', 'false');
      document.body.classList.add('ritual-sticky-atc-visible');
    } else {
      sticky.setAttribute('hidden', '');
      sticky.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('ritual-sticky-atc-visible');
    }
  }

  function bindObserver() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }

    if (!mobileMq.matches) {
      setVisible(false);
      return;
    }

    observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (!entry) return;
        setVisible(!entry.isIntersecting);
      },
      { root: null, threshold: 0, rootMargin: '0px 0px -1px 0px' }
    );
    observer.observe(mainSubmit);
  }

  stickySubmit.addEventListener('click', () => {
    if (mainSubmit.disabled) return;
    mainSubmit.click();
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      if (data?.sectionId && String(data.sectionId) !== String(sectionId)) return;
      window.requestAnimationFrame(() => {
        syncPrice();
        syncFromMainSubmit();
      });
    });
  }

  const submitObserver = new MutationObserver(() => {
    syncFromMainSubmit();
  });
  submitObserver.observe(mainSubmit, { attributes: true, attributeFilter: ['disabled'], subtree: true, childList: true });

  mobileMq.addEventListener('change', bindObserver);
  bindObserver();
  syncPrice();
  syncFromMainSubmit();
})();
